import { ROUTES } from 'app/core/router/paths';

/**
 * @description 流程步驟代碼
 */
export enum ProcessStepCodesEnum {
  /** 計算保費 (Step-1) */
  Calculation = '1',
  /** 填寫資料 (Step-2-1) */
  InsuranceInfo = '2-1',
  /** 填寫資料 (Step-2-2) */
  InsuranceInfoClauses = '2-2',
  /** 確認資料 (Step-3-1) */
  ConfirmInfo = '3-1',
  /** 確認資料 (Step-3-2) */
  ConfirmInfoOTPAuth = '3-2',
  /** 線上繳費/繳費方式 (Step-4-1) */
  Payment = '4-1',
  /** 線上繳費/帳戶轉帳 (Step-4-2) */
  PaymentTransfer = '4-2',
  /** 線上繳費/信用卡 (Step-4-2) */
  PaymentCreditCard = '4-2',
  /** 完成投保 (Step-5) */
  Complete = '5'
}

/**
 * @description 流程步驟文字
 */
export enum ProcessStepTextEnum {
  /** 計算保費 (Step-1) */
  Calculation = '計算保費',
  /** 填寫資料 (Step-2-1) */
  InsuranceInfo = '填寫資料',
  /** 填寫資料 (Step-2-2) */
  InsuranceInfoClauses = '填寫資料',
  /** 確認資料 (Step-3-1) */
  ConfirmInfo = '確認資料',
  /** 確認資料 (Step-3-2) */
  ConfirmInfoOTPAuth = '確認資料',
  /** 線上繳費/繳費方式 (Step-4-1) */
  Payment = '線上繳費',
  /** 完成投保 (Step-5) */
  Complete = '完成投保'
}

/**
 * @description 流程路由對應步驟代碼
 */
export const ProcessRouteMatchesStep: Readonly<Record<string, ProcessStepCodesEnum>> = {
  /** 計算保費 (Step-1) */
  [ROUTES.ONLINE_INSURE__TRAVEL_INSURANCE__CALCULATION]: ProcessStepCodesEnum.Calculation,
  /** 填寫資料 (Step-2-1) */
  [ROUTES.ONLINE_INSURE__TRAVEL_INSURANCE__INSURANCE_INFO]: ProcessStepCodesEnum.InsuranceInfo,
  /** 填寫資料 (Step-2-2) */
  [ROUTES.ONLINE_INSURE__TRAVEL_INSURANCE__INSURANCE_INFO__CLAUSES]: ProcessStepCodesEnum.InsuranceInfoClauses,
  /** 確認資料 (Step-3-1) */
  [ROUTES.ONLINE_INSURE__TRAVEL_INSURANCE__CONFIRM_INFO]: ProcessStepCodesEnum.ConfirmInfo,
  /** 確認資料 (Step-3-2) */
  [ROUTES.ONLINE_INSURE__TRAVEL_INSURANCE__CONFIRM_INFO__OTP_AUTH]: ProcessStepCodesEnum.ConfirmInfoOTPAuth,
  /** 線上繳費/繳費方式 (Step-4-1) */
  [ROUTES.ONLINE_INSURE__TRAVEL_INSURANCE__PAYMENT]: ProcessStepCodesEnum.Payment,
  /** 線上繳費/帳戶轉帳 (Step-4-2) */
  [ROUTES.ONLINE_INSURE__TRAVEL_INSURANCE__PAYMENT__TRANSFER]: ProcessStepCodesEnum.PaymentTransfer,
  /** 線上繳費/信用卡 (Step-4-2) */
  [ROUTES.ONLINE_INSURE__TRAVEL_INSURANCE__PAYMENT__CREDIT_CARD]: ProcessStepCodesEnum.PaymentCreditCard,
  /** 完成投保 (Step-5) */
  [ROUTES.ONLINE_INSURE__TRAVEL_INSURANCE__COMPLETE]: ProcessStepCodesEnum.Complete
};

/**
 * @description 流程步驟代碼對應路由
 */
export const ProcessStepMatchesRoute: Readonly<Record<ProcessStepCodesEnum, string>> = {
  /** 計算保費 (Step-1) */
  [ProcessStepCodesEnum.Calculation]: ROUTES.ONLINE_INSURE__TRAVEL_INSURANCE__CALCULATION,
  /** 填寫資料 (Step-2-1) */
  [ProcessStepCodesEnum.InsuranceInfo]: ROUTES.ONLINE_INSURE__TRAVEL_INSURANCE__INSURANCE_INFO,
  /** 填寫資料 (Step-2-2) */
  [ProcessStepCodesEnum.InsuranceInfoClauses]: ROUTES.ONLINE_INSURE__TRAVEL_INSURANCE__INSURANCE_INFO__CLAUSES,
  /** 確認資料 (Step-3-1) */
  [ProcessStepCodesEnum.ConfirmInfo]: ROUTES.ONLINE_INSURE__TRAVEL_INSURANCE__CONFIRM_INFO,
  /** 確認資料 (Step-3-2) */
  [ProcessStepCodesEnum.ConfirmInfoOTPAuth]: ROUTES.ONLINE_INSURE__TRAVEL_INSURANCE__CONFIRM_INFO__OTP_AUTH,
  /** 線上繳費/繳費方式 (Step-4-1) */
  [ProcessStepCodesEnum.Payment]: ROUTES.ONLINE_INSURE__TRAVEL_INSURANCE__PAYMENT,
  /** 線上繳費/帳戶轉帳 (Step-4-2) */
  [ProcessStepCodesEnum.PaymentTransfer]: ROUTES.ONLINE_INSURE__TRAVEL_INSURANCE__PAYMENT__TRANSFER,
  /** 線上繳費/信用卡 (Step-4-2) */
  [ProcessStepCodesEnum.PaymentCreditCard]: ROUTES.ONLINE_INSURE__TRAVEL_INSURANCE__PAYMENT__CREDIT_CARD,
  /** 完成投保 (Step-5) */
  [ProcessStepCodesEnum.Complete]: ROUTES.ONLINE_INSURE__TRAVEL_INSURANCE__COMPLETE
};
